<template>
  <div class="multi-choice-grid" v-safe-area-bottom>
    <div class="add-saju-button" v-wave @click="openTeleportCreatePage">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 13V16C11.5 16.2833 11.5958 16.5208 11.7875 16.7125C11.9792 16.9042 12.2167 17 12.5 17C12.7833 17 13.0208 16.9042 13.2125 16.7125C13.4042 16.5208 13.5 16.2833 13.5 16V13H16.5C16.7833 13 17.0208 12.9042 17.2125 12.7125C17.4042 12.5208 17.5 12.2833 17.5 12C17.5 11.7167 17.4042 11.4792 17.2125 11.2875C17.0208 11.0958 16.7833 11 16.5 11H13.5V8C13.5 7.71667 13.4042 7.47917 13.2125 7.2875C13.0208 7.09583 12.7833 7 12.5 7C12.2167 7 11.9792 7.09583 11.7875 7.2875C11.5958 7.47917 11.5 7.71667 11.5 8V11H8.5C8.21667 11 7.97917 11.0958 7.7875 11.2875C7.59583 11.4792 7.5 11.7167 7.5 12C7.5 12.2833 7.59583 12.5208 7.7875 12.7125C7.97917 12.9042 8.21667 13 8.5 13H11.5Z" fill="#333333"/>
      </svg>
      <span class="title4">사주 정보 추가</span>
    </div>

    <!-- Priority List -->
    <div v-if="priorityList.length > 0" class="saju-list-section">
      <div class="saju-select-item" v-wave v-for="infos in priorityList" :key="infos.id">
        <div class="saju-select-item__infos" @click="submitSelection(infos)">
          <div class="saju-select-item__title">
            <span class="title4">{{ infos.name }}</span>
            <div class="my-badge" v-if="infos.is_user_birth_info">본인</div>
<!--            <div class="my-element" v-html="getElementSvg(infos.saju_main_element)"></div>-->
            <div class="my-last" v-html="getLastUsedSvg(infos.is_last_used_birth_info)"/>
          </div>
          <div class="saju-select-item__sub-title">
            <span class="title6 gray5">{{ formatDate(infos.birth_datetime)}}</span>
            <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.5" cy="2" r="1.5" fill="#CCCCCC"/>
            </svg>
            <span class="title6 gray5">{{ formatTime(infos.birth_datetime)}}</span>
            <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.5" cy="2" r="1.5" fill="#CCCCCC"/>
            </svg>
            <span class="title6 gray5">{{ infos.gender}}</span>
          </div>
        </div>
        <div class="saju-select-item__icon" v-if="!infos.is_last_used_birth_info" @click="openTeleportEditPage(infos.id)">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3245 6.92927L13.5707 10.1755L5.99621 17.75H2.75V14.5037L10.3245 6.92927ZM11.4066 5.84721L13.0297 4.2241C13.3285 3.9253 13.8129 3.9253 14.1117 4.2241L16.2759 6.38824C16.5747 6.68705 16.5747 7.17151 16.2759 7.47031L14.6527 9.09342L11.4066 5.84721Z" fill="#CCCCCC"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Others List -->
    <div v-if="othersList.length > 0" class="saju-list-section">
      <h3 class="title5 mini-label">내가 저장한 다른 사주정보</h3>
      <div class="saju-select-item" v-wave v-for="infos in othersList" :key="infos.id">
        <div class="saju-select-item__infos" @click="submitSelection(infos)">
          <div class="saju-select-item__title">
            <span class="title4">{{ infos.name }}</span>
            <div class="my-badge" v-if="infos.is_user_birth_info">본인</div>
<!--            <div class="my-element" v-html="getElementSvg(infos.saju_main_element)"></div>-->
          </div>
          <div class="saju-select-item__sub-title">
            <span class="title6 gray5">{{ formatDate(infos.birth_datetime)}}</span>
            <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.5" cy="2" r="1.5" fill="#CCCCCC"/>
            </svg>
            <span class="title6 gray5">{{ formatTime(infos.birth_datetime)}}</span>
            <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.5" cy="2" r="1.5" fill="#CCCCCC"/>
            </svg>
            <span class="title6 gray5">{{ infos.gender}}</span>
          </div>
        </div>
        <div class="saju-select-item__icon" @click="openTeleportEditPage(infos.id)">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3245 6.92927L13.5707 10.1755L5.99621 17.75H2.75V14.5037L10.3245 6.92927ZM11.4066 5.84721L13.0297 4.2241C13.3285 3.9253 13.8129 3.9253 14.1117 4.2241L16.2759 6.38824C16.5747 6.68705 16.5747 7.17151 16.2759 7.47031L14.6527 9.09342L11.4066 5.84721Z" fill="#CCCCCC"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/ko';
import {logEvent} from "@/tarot_box/helper/native_api";

export default {
  name: 'UserBirthInfoSelection',
  props: {
    options: Array,
    title: String,
    subTitle: String,
    modelValue: [String, Number],
    userBirthInfos: {
      type: Array,
      default: () => []
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    inputSections: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    priorityList() {
      if (!this.userBirthInfos) return [];
      return this.userBirthInfos
          .filter(info => {
            // 필수값 체크
            const hasRequiredFields = info.name &&
                info.gender &&
                info.birth_datetime &&
                info.saju_main_element;
            return hasRequiredFields &&
                (info.is_user_birth_info || info.is_last_used_birth_info);
          })
          .sort((a, b) => {
            if (a.is_user_birth_info && !b.is_user_birth_info) return -1;
            if (!a.is_user_birth_info && b.is_user_birth_info) return 1;
            if (a.is_last_used_birth_info && !b.is_last_used_birth_info) return -1;
            if (!a.is_last_used_birth_info && b.is_last_used_birth_info) return 1;
            return 0;
          });
    },
    othersList() {
      if (!this.userBirthInfos) return [];
      return this.userBirthInfos
          .filter(info => {
            const hasRequiredFields = info.name &&
                info.gender &&
                info.birth_datetime &&
                info.saju_main_element;
            return hasRequiredFields &&
                !info.is_user_birth_info &&
                !info.is_last_used_birth_info;
          });
    }
  },
  methods: {
    submitSelection(infos) {
      let section = this.inputSections[this.currentIndex- 1].sectionType;
      console.log(section)
      let sajuType = 'saved';
      if (infos.is_user_birth_info) {
        sajuType = 'mine';
      } else if (infos.is_last_used_birth_info) {
        sajuType = 'last_used';
      }
      logEvent('sajulist_list_click', {
        'section': section,
        'type': sajuType,
      });
      const selectedInfo = {
        name: infos.name,
        birth_datetime: infos.birth_datetime,
        gender: infos.gender
      };

      setTimeout(() => this.$emit('select', selectedInfo), 300);
    },
    formatDate(datetime) {
      return moment(datetime).format('YYYY년 M월 D일');
    },
    formatTime(datetime) {
      return moment(datetime).format('A h시 mm분');
    },
    getElementSvg(element) {
      switch (element) {
        case '水':
          return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="9" cy="9" r="9" fill="#525252"/>' +
              '<path d="M4.52 6.96H7.3V8.17H4.52V6.96ZM8.4 4.51H9.68V12.34C9.68 12.7 9.63667 12.98 9.55 13.18C9.46333 13.38 9.31333 13.5333 9.1 13.64C8.88667 13.7467 8.61333 13.8167 8.28 13.85C7.95333 13.89 7.56 13.91 7.1 13.91C7.08667 13.7833 7.05333 13.6367 7 13.47C6.95333 13.31 6.89667 13.15 6.83 12.99C6.76333 12.8233 6.69667 12.6833 6.63 12.57C6.95667 12.5833 7.26333 12.59 7.55 12.59C7.83667 12.59 8.03 12.59 8.13 12.59C8.23 12.59 8.3 12.57 8.34 12.53C8.38 12.49 8.4 12.4267 8.4 12.34V4.51ZM6.89 6.96H7.14L7.36 6.91L8.18 7.21C8.03333 8.12333 7.81333 8.95333 7.52 9.7C7.23333 10.4467 6.89333 11.1033 6.5 11.67C6.11333 12.23 5.68 12.6867 5.2 13.04C5.13333 12.94 5.04 12.83 4.92 12.71C4.8 12.5833 4.67333 12.4633 4.54 12.35C4.41333 12.2367 4.3 12.15 4.2 12.09C4.66 11.7767 5.07 11.3833 5.43 10.91C5.79 10.43 6.09333 9.88 6.34 9.26C6.59333 8.63333 6.77667 7.95333 6.89 7.22V6.96ZM9.6 5.97C9.76 6.63667 9.96333 7.27667 10.21 7.89C10.4633 8.50333 10.76 9.07667 11.1 9.61C11.44 10.1433 11.8333 10.62 12.28 11.04C12.7333 11.4533 13.24 11.7933 13.8 12.06C13.7 12.14 13.59 12.2433 13.47 12.37C13.35 12.4967 13.2367 12.6333 13.13 12.78C13.03 12.92 12.9433 13.05 12.87 13.17C12.0967 12.73 11.44 12.1633 10.9 11.47C10.36 10.77 9.91 9.97 9.55 9.07C9.19 8.17 8.89 7.20333 8.65 6.17L9.6 5.97ZM12.41 6.07L13.54 6.86C13.2533 7.15333 12.95 7.45667 12.63 7.77C12.31 8.08333 11.99 8.38 11.67 8.66C11.3567 8.94 11.06 9.18333 10.78 9.39L9.91 8.72C10.1833 8.49333 10.47 8.23 10.77 7.93C11.0767 7.63 11.3733 7.32 11.66 7C11.9467 6.67333 12.1967 6.36333 12.41 6.07Z" fill="white"/>' +
              '</svg>';
        case '金':
          return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<circle cx="9" cy="9" r="9" fill="#CFCFCF"/>\n' +
              '<path d="M8.96 5.65C8.68667 6.03 8.34 6.42333 7.92 6.83C7.50667 7.23667 7.04667 7.62667 6.54 8C6.04 8.37333 5.51667 8.70667 4.97 9C4.91667 8.9 4.84667 8.79 4.76 8.67C4.68 8.55 4.59 8.43333 4.49 8.32C4.39667 8.20667 4.30667 8.10667 4.22 8.02C4.79333 7.74667 5.34333 7.41 5.87 7.01C6.39667 6.60333 6.86667 6.18 7.28 5.74C7.7 5.3 8.03333 4.87667 8.28 4.47H9.53C9.80333 4.85 10.1033 5.21333 10.43 5.56C10.7567 5.90667 11.1067 6.22667 11.48 6.52C11.8533 6.81333 12.2367 7.07667 12.63 7.31C13.0233 7.54333 13.42 7.74 13.82 7.9C13.6667 8.05333 13.5233 8.22667 13.39 8.42C13.2567 8.61333 13.1333 8.8 13.02 8.98C12.64 8.78 12.2533 8.55 11.86 8.29C11.4733 8.03 11.1 7.75333 10.74 7.46C10.38 7.16 10.0467 6.85667 9.74 6.55C9.43333 6.24333 9.17333 5.94333 8.96 5.65ZM6.46 7.5H11.49V8.55H6.46V7.5ZM5.26 9.54H12.67V10.58H5.26V9.54ZM4.76 12.58H13.26V13.61H4.76V12.58ZM8.31 7.92H9.58V13.1H8.31V7.92ZM5.89 10.96L6.85 10.56C6.97667 10.7267 7.1 10.91 7.22 11.11C7.34667 11.31 7.46 11.5067 7.56 11.7C7.66 11.8933 7.73333 12.0667 7.78 12.22L6.75 12.68C6.71 12.5267 6.64333 12.35 6.55 12.15C6.45667 11.9433 6.35333 11.7367 6.24 11.53C6.12667 11.3233 6.01 11.1333 5.89 10.96ZM10.97 10.57L12.12 10.99C11.92 11.2967 11.7133 11.6033 11.5 11.91C11.2867 12.21 11.09 12.4667 10.91 12.68L10.01 12.3C10.1233 12.14 10.24 11.9633 10.36 11.77C10.48 11.57 10.5933 11.3667 10.7 11.16C10.8067 10.9467 10.8967 10.75 10.97 10.57Z" fill="#121212"/>\n' +
              '</svg>';
        case '土':
          return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<circle cx="9" cy="9" r="9" fill="#F4D156"/>\n' +
              '<path d="M5.12 7.61H12.9V8.79H5.12V7.61ZM4.46 12.29H13.57V13.47H4.46V12.29ZM8.34 4.52H9.63V13.1H8.34V4.52Z" fill="#121212"/>\n' +
              '</svg>'
        case '木':
          return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<circle cx="9" cy="9" r="9" fill="#4768A8"/>\n' +
              '<path d="M4.61 6.84H13.41V8.03H4.61V6.84ZM8.36 4.51H9.64V13.9H8.36V4.51ZM8.1 7.49L9.16 7.85C8.93333 8.37667 8.67333 8.88667 8.38 9.38C8.08667 9.87333 7.76333 10.34 7.41 10.78C7.06333 11.22 6.69 11.6267 6.29 12C5.89667 12.3667 5.48333 12.6833 5.05 12.95C4.98333 12.85 4.89667 12.7367 4.79 12.61C4.68333 12.4833 4.57333 12.36 4.46 12.24C4.34667 12.1133 4.24333 12.01 4.15 11.93C4.56333 11.7033 4.96333 11.43 5.35 11.11C5.74333 10.7833 6.11333 10.4267 6.46 10.04C6.80667 9.64667 7.11667 9.23333 7.39 8.8C7.67 8.36667 7.90667 7.93 8.1 7.49ZM9.87 7.54C10.0633 7.96667 10.3033 8.39 10.59 8.81C10.8767 9.23 11.1933 9.63 11.54 10.01C11.8933 10.39 12.2633 10.74 12.65 11.06C13.0367 11.38 13.4333 11.65 13.84 11.87C13.7467 11.9433 13.64 12.0433 13.52 12.17C13.4067 12.29 13.2967 12.4167 13.19 12.55C13.09 12.6833 13.0067 12.8033 12.94 12.91C12.52 12.6433 12.1167 12.33 11.73 11.97C11.3433 11.6033 10.9733 11.2033 10.62 10.77C10.2667 10.33 9.94333 9.86667 9.65 9.38C9.35667 8.89333 9.09333 8.39667 8.86 7.89L9.87 7.54Z" fill="white"/>\n' +
              '</svg>'; // Wood SVG
        case '火':
          return '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<circle cx="9" cy="9" r="9" fill="#CF5354"/>\n' +
              '<path d="M5.77 6.49L6.98 6.76C6.92667 7.17333 6.85 7.57667 6.75 7.97C6.65667 8.36333 6.52333 8.73 6.35 9.07C6.17667 9.40333 5.94667 9.69 5.66 9.93L4.57 9.25C4.81667 9.04333 5.01667 8.8 5.17 8.52C5.33 8.23333 5.45667 7.92 5.55 7.58C5.65 7.23333 5.72333 6.87 5.77 6.49ZM11.91 6.48L13.24 6.98C13.0667 7.3 12.8867 7.63 12.7 7.97C12.5133 8.30333 12.3267 8.62333 12.14 8.93C11.96 9.23 11.7833 9.49333 11.61 9.72L10.58 9.26C10.7333 9.01333 10.8933 8.73 11.06 8.41C11.2333 8.09 11.3933 7.76333 11.54 7.43C11.6867 7.09 11.81 6.77333 11.91 6.48ZM8.95 4.64H9.6V7.78C9.6 8.02667 9.62667 8.29667 9.68 8.59C9.74 8.88333 9.83333 9.18333 9.96 9.49C10.0867 9.79667 10.2533 10.1033 10.46 10.41C10.6733 10.7167 10.93 11.0133 11.23 11.3C11.53 11.5867 11.88 11.8567 12.28 12.11C12.6867 12.3567 13.15 12.5767 13.67 12.77C13.5767 12.8567 13.4767 12.9667 13.37 13.1C13.2633 13.2333 13.16 13.37 13.06 13.51C12.9667 13.65 12.89 13.7767 12.83 13.89C12.35 13.6967 11.9167 13.4667 11.53 13.2C11.1433 12.9333 10.8 12.6533 10.5 12.36C10.2067 12.06 9.95333 11.76 9.74 11.46C9.52667 11.16 9.35333 10.8767 9.22 10.61C9.09333 10.3433 9 10.11 8.94 9.91C8.89333 10.1167 8.80667 10.3533 8.68 10.62C8.56 10.8867 8.39667 11.17 8.19 11.47C7.99 11.7633 7.74667 12.0567 7.46 12.35C7.18 12.6433 6.85 12.9233 6.47 13.19C6.09667 13.4567 5.67667 13.69 5.21 13.89C5.15667 13.7967 5.08 13.6867 4.98 13.56C4.88 13.4333 4.77333 13.3067 4.66 13.18C4.54667 13.0533 4.44667 12.95 4.36 12.87C4.96667 12.6433 5.49 12.37 5.93 12.05C6.37667 11.7233 6.75 11.3767 7.05 11.01C7.35 10.6433 7.59 10.27 7.77 9.89C7.95667 9.50333 8.09 9.13333 8.17 8.78C8.25667 8.42 8.3 8.08667 8.3 7.78V4.64H8.95Z" fill="white"/>\n' +
              '</svg>'; // Fire SVG
        default:
          return '';
      }
    },
    getLastUsedSvg(lastUsed) {
      if (lastUsed === true) {
        return '<svg width="98" height="17" viewBox="0 0 98 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<rect width="98" height="17" rx="4" fill="#E3E6ED"/>' +
            '<path d="M11.896 3.28H13.216V9.724H11.896V3.28ZM4.48 8.5C6.184 7.924 7.072 6.532 7.072 5.128V5.008H4.828V3.964H10.648V5.008H8.416V5.128C8.416 6.46 9.34 7.756 11.008 8.308L10.336 9.328C9.124 8.944 8.26 8.128 7.78 7.108C7.3 8.212 6.412 9.088 5.152 9.52L4.48 8.5ZM6.004 11.296V10.24H13.216V13.972H11.896V11.296H6.004ZM20.5843 6.112H22.4443V3.292H23.7643V11.08H22.4443V7.18H20.5843V6.112ZM14.8603 8.8C16.5523 8.224 17.4523 6.82 17.4523 5.404V5.116H15.2323V4.06H20.9683V5.116H18.7843V5.404C18.7843 6.7 19.6363 8.032 21.2683 8.584L20.6203 9.616C19.4323 9.208 18.6043 8.392 18.1363 7.372C17.6803 8.5 16.7923 9.412 15.5323 9.844L14.8603 8.8ZM16.7923 13.756V10.42H18.1243V12.7H24.0283V13.756H16.7923ZM33.2566 3.28H34.5046V13.96H33.2566V3.28ZM25.4806 7.9C25.4806 5.536 26.3806 4.084 27.7726 4.084C29.0566 4.084 29.9206 5.296 30.0646 7.3H31.0966V3.484H32.3326V13.456H31.0966V8.368H30.0766C29.9686 10.468 29.0806 11.728 27.7726 11.728C26.3806 11.728 25.4806 10.276 25.4806 7.9ZM26.6806 7.9C26.6806 9.58 27.0886 10.492 27.7726 10.492C28.4686 10.492 28.8766 9.58 28.8766 7.9C28.8766 6.232 28.4686 5.332 27.7726 5.332C27.0886 5.332 26.6806 6.232 26.6806 7.9ZM46.1265 3.292H47.4465V9.016H46.1265V3.292ZM38.8185 6.244C38.8185 4.78 40.0305 3.76 41.6745 3.76C43.3185 3.76 44.5305 4.78 44.5305 6.244C44.5305 7.72 43.3185 8.74 41.6745 8.74C40.0305 8.74 38.8185 7.72 38.8185 6.244ZM40.1025 6.244C40.1025 7.108 40.7625 7.648 41.6745 7.648C42.5865 7.648 43.2465 7.108 43.2465 6.244C43.2465 5.392 42.5865 4.84 41.6745 4.84C40.7625 4.84 40.1025 5.392 40.1025 6.244ZM40.4385 13.84V9.52H41.7465V10.624H46.1505V9.52H47.4465V13.84H40.4385ZM41.7465 12.784H46.1505V11.644H41.7465V12.784ZM49.5107 3.904H54.1788V7.144H50.8548V8.452C52.5588 8.44 53.5068 8.392 54.6468 8.2L54.7787 9.244C53.5068 9.472 52.4148 9.508 50.3268 9.508H49.5348V6.148H52.8828V4.972H49.5107V3.904ZM50.7468 11.44V10.384H57.9948V13.984H56.6748V11.44H50.7468ZM54.8268 8.104V7.06H56.6748V5.872H54.8268V4.804H56.6748V3.292H57.9948V9.868H56.6748V8.104H54.8268ZM66.647 3.292H67.967V6.64H69.455V7.732H67.967V11.284H66.647V3.292ZM59.627 5.512V4.468H62.111V3.28H63.431V4.468H65.915V5.512H59.627ZM60.179 8.008C60.179 6.796 61.247 5.98 62.771 5.98C64.307 5.98 65.375 6.796 65.375 8.008C65.375 9.232 64.307 10.048 62.771 10.048C61.247 10.048 60.179 9.232 60.179 8.008ZM61.175 13.756V10.66H62.495V12.7H68.399V13.756H61.175ZM61.439 8.008C61.439 8.656 61.979 9.028 62.771 9.028C63.563 9.028 64.103 8.656 64.103 8.008C64.103 7.36 63.563 6.988 62.771 6.988C61.979 6.988 61.439 7.36 61.439 8.008ZM75.3529 4.156H76.6609V5.836C76.6609 7.732 77.5849 9.688 79.2289 10.492L78.4249 11.536C77.2849 10.948 76.4689 9.832 76.0129 8.476C75.5449 9.928 74.6809 11.128 73.4689 11.74L72.6769 10.672C74.3809 9.856 75.3529 7.804 75.3529 5.836V4.156ZM79.8409 13.972V3.292H81.1729V7.48H82.8049V8.584H81.1729V13.972H79.8409ZM83.3572 9.256H93.0172V10.324H88.8172V13.984H87.4972V10.324H83.3572V9.256ZM83.8612 7.492C85.9492 7.228 87.3292 6.1 87.4252 4.936H84.2332V3.88H92.1172V4.936H88.9492C89.0452 6.1 90.4252 7.228 92.5132 7.492L92.0212 8.548C90.2332 8.284 88.8292 7.432 88.1812 6.28C87.5452 7.432 86.1412 8.284 84.3532 8.548L83.8612 7.492Z" fill="#1E2352"/>' +
            '</svg>'
      }
    },
    openTeleportEditPage(id) {
      logEvent('sajulist_edit_click', {});
      this.$emit('open-edit', id);
    },
    openTeleportCreatePage() {
      logEvent('sajulist_add_click', {});
      this.$emit('open-create');
    }
  },
  emits: ['select', 'open-edit', 'open-create']
}
</script>

<style scoped>
.multi-choice-grid {
  margin-top: 56px;
  padding: 20px;
}

.add-saju-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  background-color: var(--gray11);
  color: var(--gray3);
  gap: 8px;
  margin-bottom: 24px;
}

.saju-list-section {
  margin-bottom: 20px;
  border-bottom: 2px solid var(--Grayscale-Gray10);
}

.saju-select-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  border-bottom: 1px solid var(--Grayscale-Gray11);
}

.saju-select-item:last-child {
  border-bottom: none;
}

.saju-select-item__infos {
  display: flex;
  flex: 6;
  flex-direction: column;
  gap: 4px;
}

.saju-select-item__icon {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.saju-select-item__title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  line-height: 1;
}

.my-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 4px;
  color: white;
  background-color: var(--Color-palette-Primary-Default);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.my-element {
  display: flex;
  justify-content: center;
  align-items: center;
}

.saju-select-item__sub-title {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}

.mini-label{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: var(--Grayscale-Gray11);
  padding: 8px 18px;
  box-sizing: border-box;
  border-radius: 8px;
}
</style>
